export default __webpack_public_path__ + "static/media/demo2.ab550d5e.gif";